{********************************************************************}
{                                                                    }
{ written by TMS Software                                            }
{            Copyright (c) 2021                                      }
{            Email : info@tmssoftware.com                            }
{            Web : http://www.tmssoftware.com                        }
{                                                                    }
{ The source code is given as is. The author is not responsible      }
{ for any possible damage done due to the use of this code.          }
{ The complete source code remains property of the author and may    }
{ not be distributed, published, given or sold in any form as such.  }
{ No parts of the source code can be included in any other component }
{ or application without written authorization of the author.        }
{********************************************************************}

unit NetEncoding;

interface

uses
  Web, Classes, JS, SysUtils;

type
  TNetEncoding = class
  public
  end;

  TBase64Encoding = class(TNetEncoding)
  public
    function Decode(const Input: array of Byte): TBytes; overload;
    function Decode(const Input: string): string; overload;
    function Encode(const Input: array of Byte): TBytes; overload;
    function Encode(const Input: string): string; overload;
  end;

  TURLEncoding = class(TNetEncoding)
    function Decode(const Input: string): string; overload;
    function Encode(const Input: string): string; overload;

  end;

implementation

function StringToArray(AText: string): TJSArrayBuffer;
var
  arr: TJSArrayBuffer;
begin
  asm
    let enc = new TextEncoder();
    arr = enc.encode(AText);
  end;
  Result := arr;
end;

function ArrayToString(AArray: TJSArrayBuffer): string;
var
  s: string;
begin
  asm
    let dec = new TextDecoder();
    s = dec.decode(AArray);
  end;
  Result := s;
end;

{ TBase64Encoding }

function TBase64Encoding.Decode(const Input: array of Byte): TBytes;
var
  s: string;
begin
  s := ArrayToString(TJSArrayBuffer(Input));
  s := window.atob(s);
  Result := TBytes(StringToArray(s));
end;

function TBase64Encoding.Decode(const Input: string): string;
begin
  Result := window.atob(Input);
end;

function TBase64Encoding.Encode(const Input: array of Byte): TBytes;
var
  s: string;
begin
  s := ArrayToString(TJSArrayBuffer(Input));
  s := window.btoa(s);
  Result := TBytes(StringToArray(s));
end;

function TBase64Encoding.Encode(const Input: string): string;
begin
  Result := window.btoa(Input);
end;

{ TURLEncoding }

function TURLEncoding.Decode(const Input: string): string;
var
  s: string;
begin
  s := '';
  asm
    s = decodeURI(Input);
  end;
  Result := s;
end;

function TURLEncoding.Encode(const Input: string): string;
var
  s: string;
begin
  s := '';
  asm
    s = encodeURI(Input);
  end;
  Result := s;
end;

end.
